import React, { memo, useCallback, useEffect } from 'react';
import { useIntl } from 'react-intl';
import PropTypes from 'prop-types';
import { PAYMENT_METHOD } from 'src/modules/Order/constants';

import Button from 'src/components/Button';
import FontIcon from 'src/components/FontIcon';

import theme from 'src/styles/components/CloseBillButton.module.scss';

const CloseBillButton = memo(({
    context,
    submitCloseBill,
    isPaymentAllow,
    canOrder,
    emitMessage,
    dismissFirstMessage,
    askForBillError,
    pushNotification,
    clearAskForBillError
}) => {
    const intl = useIntl();

    useEffect(() => {
        if (askForBillError) {
            pushNotification({
                message: (
                    <div className={theme.notification}>
                        <div className={theme.notificationIcon}>
                            <FontIcon value="icon-info" />
                        </div>
                        {intl.formatMessage({ id: `Error.${askForBillError}` })}
                    </div>
                ),
                isDismissButtonEnabled: false
            });
            clearAskForBillError();
        }
    }, [askForBillError]);

    const handleCloseBill = useCallback(() => {
        if (isPaymentAllow) {
            emitMessage({
                type: 'info',
                subtitle: intl.formatMessage({ id: 'App.choose' }),
                title: intl.formatMessage({ id: 'App.paymentMethod' }),
                message: <div className={theme.popupDescription}>
                    {intl.formatMessage({ id: 'App.areYouSureCloseBill' })}
                </div>,
                isEscKeyDownEnabled: true,
                isDismissButtonEnabled: true,
                shouldBeFirst: true,
                actions: (
                    <div className={theme.actionContainer}>
                        <Button
                          className={theme.actionButton}
                          label={intl.formatMessage({ id: 'App.terminal' })}
                          onClick={() => {
                            submitCloseBill(context, PAYMENT_METHOD.TERMINAL);
                            dismissFirstMessage();
                          }}
                          inverse
                          raised
                        />
                        <Button
                          className={theme.actionButton}
                          label={intl.formatMessage({ id: 'App.cash' })}
                          onClick={() => {
                            submitCloseBill(context, PAYMENT_METHOD.CASH);
                            dismissFirstMessage();
                          }}
                          inverse
                          raised
                        />
                    </div>
                ),
                backgroundIcon: 'icon-payment'
            });
        }
    }, [context, isPaymentAllow]);

    return (
        <Button
          onClick={handleCloseBill}
          className={theme.button}
          disabled={!isPaymentAllow}
          raised
          secondary={canOrder}
          accent={!canOrder}
        >{intl.formatMessage({ id: 'App.askForBill' })}</Button>
    );
});

CloseBillButton.propTypes = {
    context: PropTypes.object,
    isPaymentAllow: PropTypes.bool.isRequired,
    submitCloseBill: PropTypes.func.isRequired,
    canOrder: PropTypes.bool,
    emitMessage: PropTypes.func.isRequired,
    dismissFirstMessage: PropTypes.func.isRequired,
    askForBillError: PropTypes.string,
    pushNotification: PropTypes.func.isRequired,
    clearAskForBillError: PropTypes.func.isRequired
};

export default CloseBillButton;
